import generatedCatInAFlatTheme from '@rover/kibble/tokens/build/ciaf/es6/theme';

import { breakpoints } from './themeConstants';

const ciafTheme = {
  ...generatedCatInAFlatTheme,
  breakpoints,
};

export default ciafTheme;
